exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-card[data-v-0812e619] {\n  width: 100%;\n  height: 100%;\n}\n.code[data-v-0812e619] {\n  width: 250px;\n  background-color: #fff;\n  margin: 0 auto;\n}\n.code .wx_code[data-v-0812e619] {\n    width: 250px;\n    height: 250px;\n}\n.code .code_text[data-v-0812e619] {\n    padding-top: 20px;\n    line-height: 22px;\n    text-align: center;\n}\n", ""]);

// exports
